import { Location } from "history";
import { useEffect, useState } from "react";
import { MdWarning } from "react-icons/md";
import { SimpleActionDialog } from "..";
import { usePrompt } from "../../hooks/NavigationBlocker";
import { theme } from "../../theme";

interface Props {
  when?: boolean | undefined;
  navigate: (path: string) => void;
  shouldBlockNavigation: (location: Location) => boolean;
}

// function to check if form values have been touched
export const formHasChangedValues = (
  initialValues: any,
  currentValues: any
) => {
  return Object.keys(initialValues).some((key) => {
    return initialValues[key] !== currentValues[key];
  });
};

// component which is wrapping the prompt dialog which is shown before navigating away from a page
const RouteLeavingGuard = ({
  when,
  navigate,
  // shouldBlockNavigation,
}: Props) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation,] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      navigate(lastLocation.pathname);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmedNavigation, lastLocation]);

  // const handleBlockedNavigation = (nextLocation: Location): boolean => {
  //   if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
  //     setModalVisible(true);
  //     setLastLocation(nextLocation);
  //     return false;
  //   }
  //   return true;
  // };

  const handleConfirmNavigationClick = () => {
    setModalVisible(false);
    setConfirmedNavigation(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  usePrompt('You have unsaved changes. Are you sure you want to leave this page without saving?', when)

  return (
    <>
      {/* <Prompt when={when} message={handleBlockedNavigation} /> */}
      
      <SimpleActionDialog
        open={modalVisible}
        icon={<MdWarning size="45" color={theme.palette.primary.main} />}
        title="Close without saving?"
        content="You have unsaved changes. Are you sure you want to leave this page without saving?"
        onCancel={closeModal}
        onConfirm={handleConfirmNavigationClick}
      />
    </>
  );
};
export default RouteLeavingGuard;
